"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentProductBillingBasis = void 0;
var PaymentProductBillingBasis;
(function (PaymentProductBillingBasis) {
    PaymentProductBillingBasis["AREA"] = "area";
    PaymentProductBillingBasis["AREA_ADJUSTED"] = "area-adjusted";
    PaymentProductBillingBasis["SHARE_COUNT"] = "share-count";
    PaymentProductBillingBasis["RESIDENT_COUNT"] = "resident-count";
    PaymentProductBillingBasis["PIECES"] = "pieces";
})(PaymentProductBillingBasis = exports.PaymentProductBillingBasis || (exports.PaymentProductBillingBasis = {}));
